module.exports = __webpack_public_path__ + "static/media/icon_tick_successful.7d44f9d7.svg";